import { config } from "../config";
import { ENTITY } from "./entities";

const baseApiUrl = config.apiUrl;

export const AUTH_URL = `${baseApiUrl}/auth`;
export const AUTH_REGISTER_URL = `${baseApiUrl}/auth/register`;
export const AUTH_LOGIN_URL = `${baseApiUrl}/auth/access-token`;
export const AUTH_REFRESH_URL = `${baseApiUrl}/auth/refresh-token`;

export const FILES_URL = `${baseApiUrl}/files/`;
export const FILES_UPLOADS_URL = `${FILES_URL}uploads`;
export const getFileConfirmUrl = (fileId: number) => `${FILES_URL}${fileId}/confirm`;

export const USERS_URL = `${baseApiUrl}/${ENTITY.USERS}/`;
export const CLIENTS_URL = `${baseApiUrl}/${ENTITY.CLIENTS}/`;
export const ASSOCIATED_CLIENTS_URL = `${baseApiUrl}/${ENTITY.ASSOCIATED_CLIENTS}/`;
export const ARTICLES_URL = `${baseApiUrl}/${ENTITY.ARTICLES}/`;
export const STORES_URL = `${baseApiUrl}/${ENTITY.STORES}/`;
export const UNITS_URL = `${baseApiUrl}/${ENTITY.UNITS}/`;
export const CONTAINERS_URL = `${baseApiUrl}/${ENTITY.CONTAINERS}/`;
export const ADDITIONAL_ITEMS_URL = `${baseApiUrl}/${ENTITY.ADDITIONAL_ITEMS}/`;
export const SETTLEMENT_TYPES_URL = `${baseApiUrl}/${ENTITY.SETTLEMENT_TYPES}/`;
export const CLIENT_SETTLEMENT_TYPES_URL = `${baseApiUrl}/${ENTITY.CLIENT_SETTLEMENT_TYPES}/`;
export const MOVEMENTS_URL = `${baseApiUrl}/${ENTITY.MOVEMENTS}/`;
export const MOVEMENTS_EXPORT_URL = `${MOVEMENTS_URL}export`;
export const MOVEMENTS_FILTER_OPTIONS_URL = `${MOVEMENTS_URL}filter-options`;
export const MOVEMENT_BATCHES_URL = `${baseApiUrl}/${ENTITY.MOVEMENT_BATCHES}/`;
export const MOVEMENT_TYPES_URL = `${baseApiUrl}/${ENTITY.MOVEMENT_TYPES}/`;
export const ORDERS_URL = `${baseApiUrl}/orders/`;
export const ORDERS_FROM_FILE_URL = `${ORDERS_URL}from-file`;
export const ORDERS_IMPORT_URL = `${ORDERS_URL}import`;
export const ORDERS_IMPORT_PREVIEW_URL = `${ORDERS_URL}import/preview`;
export const ORDERS_STATUS_BATCH_URL = `${ORDERS_URL}status/batch`;
export const ORDERS_DISPATCH_BATCH_URL = `${ORDERS_URL}dispatch/batch`;
export const LOCATIONS_URL = `${baseApiUrl}/${ENTITY.LOCATIONS}/`;
export const SUBLOCATIONS_URL = `${baseApiUrl}/${ENTITY.SUBLOCATIONS}/`;
export const MOVEMENT_ARTICLES_URL = `${baseApiUrl}/${ENTITY.MOVEMENT_ARTICLES}/`;
export const MOVEMENT_ARTICLES_GROUPED_OUTCOME_URL = `${MOVEMENT_ARTICLES_URL}grouped-outcome`;
export const MOVEMENT_ARTICLES_GROUPED_OUTCOME_OBSERVATION_PREVIEW_URL = `${MOVEMENT_ARTICLES_URL}grouped-outcome/observation-preview`;
export const MOVEMENT_ARTICLES_GROUPED_OUTCOME_STOCK_UNIT_SELECTION_POOL_URL = `${MOVEMENT_ARTICLES_URL}grouped-outcome/stock-unit-selection-pool`;
export const MOVEMENT_ARTICLES_TRANSFER_ORIGINS_URL = `${MOVEMENT_ARTICLES_URL}transfer-origins`;
export const MOVEMENT_ARTICLES_TRANSFER_ORIGIN_STOCK_UNIT_SELECTION_POOL_URL = `${MOVEMENT_ARTICLES_URL}transfer-origins/stock-unit-selection-pool`;
export const ARTICLE_LOCATIONS_URL = `${baseApiUrl}/${ENTITY.ARTICLE_LOCATIONS}/`;
export const LIQUIDATIONS_URL = `${baseApiUrl}/${ENTITY.LIQUIDATIONS}/`;
export const LIQUIDATIONS_BATCH_URL = `${LIQUIDATIONS_URL}batch`;
export const LIQUIDATION_BATCHES_URL = `${baseApiUrl}/${ENTITY.LIQUIDATION_BATCHES}/`;
export const ADDITIONAL_ITEMS_IN_MOVEMENTS_URL = `${baseApiUrl}/${ENTITY.MOVEMENTS}/${ENTITY.ADDITIONAL_ITEMS}/`;
export const CASCADE_STARTS_URL = `${baseApiUrl}/${ENTITY.CASCADE_STARTS}/`;
export const INVENTORY_ADJUSTMENTS_URL = `${baseApiUrl}/${ENTITY.INVENTORY_ADJUSTMENT}/`;
export const HISTORY_URL = `${baseApiUrl}/${ENTITY.MOVEMENT_ARTICLES}/history`;
export const HISTORY_GROUPED_BY_LOTE_URL = `${baseApiUrl}/${ENTITY.MOVEMENT_ARTICLES}/history/grouped-by-lote`;
export const MOVEMENTS_NEXT_ADJUSTMENT_DOC_URL = `${baseApiUrl}/${ENTITY.MOVEMENTS}/next-adjustment-document/`;
export const GROUPS_URL = `${baseApiUrl}/${ENTITY.GROUPS}/`;
export const ARTICLE_LOCATION_STATE_URL = `${ARTICLE_LOCATIONS_URL}state/`;
export const ARTICLE_LOCATIONS_BY_DATE_URL = `${ARTICLE_LOCATIONS_URL}by-date`;
export const ARTICLE_LOCATIONS_BY_DATE_EXPORT_URL = `${ARTICLE_LOCATIONS_BY_DATE_URL}/export`;
export const ARTICLE_LOCATIONS_EXPANDED_EXPORT_URL = `${ARTICLE_LOCATIONS_URL}expanded/export`;
export const ARTICLE_LOCATIONS_SUMMARY_EXPORT_URL = `${ARTICLE_LOCATIONS_URL}summary/export`;
export const PREPICKING_VALIDATE_URL = `${baseApiUrl}/prepicking/validate`;
export const INCOME_ENTRIES_URL = `${baseApiUrl}/${ENTITY.INCOME_ENTRIES}/`;
export const getIncomeEntryRemitoDownloadUrl = (id: number) => `${INCOME_ENTRIES_URL}${id}/remito/download`;
export const getIncomeEntryPhotoDownloadUrl = (id: number) => `${INCOME_ENTRIES_URL}${id}/photo/download`;
export const getIncomeEntryObservationPhotoDownloadUrl = (id: number, observationId: number) =>
  `${INCOME_ENTRIES_URL}${id}/observations/${observationId}/photo/download`;
export const WORK_ORDERS_URL = `${baseApiUrl}/work_orders/`;
export const getWorkOrderUrl = (id: number | string) => `${WORK_ORDERS_URL}${id}`;
export const getWorkOrderBundleUrl = (id: number | string, bundleId: number | string) =>
  `${getWorkOrderUrl(id)}/bundles/${bundleId}`;
export const getWorkOrderBundleClaimUrl = (id: number | string, bundleId: number | string) =>
  `${getWorkOrderBundleUrl(id, bundleId)}/claim`;
export const getWorkOrderBundleReleaseUrl = (id: number | string, bundleId: number | string) =>
  `${getWorkOrderBundleUrl(id, bundleId)}/release`;

export const buildOrderDispatchBatchUrl = (batchId: number | string) =>
  `${ORDERS_URL}dispatch/batch/${batchId}`;
export const getOrderStatusUrl = (orderId: number | string) =>
  `${ORDERS_URL}${orderId}/status`;
export const getOrderCancelUrl = (orderId: number | string) =>
  `${ORDERS_URL}${orderId}/cancel`;
export const getOrderRemitoDownloadUrl = (orderId: number) =>
  `${ORDERS_URL}${orderId}/remito/download`;
export const getRelatedAdditionalMovementsUrl = (
  movementId: number | string,
) => `${MOVEMENTS_URL}${movementId}/related-additionals`;
export const getArticleLocationObservationRecordsUrl = (
  articleLocationId: number | string,
) => `${ARTICLE_LOCATIONS_URL}${articleLocationId}/observation-records`;

export const ENTITY_NAMES = {
  [STORES_URL]: "Almacén",
  [LOCATIONS_URL]: "Ubicación",
  [MOVEMENTS_URL]: "Movimiento",
  [CLIENTS_URL]: "Cliente",
  [ASSOCIATED_CLIENTS_URL]: "Cliente asociado",
  [ARTICLES_URL]: "Artículo",
  [UNITS_URL]: "Unidad",
  [CONTAINERS_URL]: "Contenedor",
  [ADDITIONAL_ITEMS_URL]: "Item adicional",
  [SETTLEMENT_TYPES_URL]: "Tipo de liquidación",
  [USERS_URL]: "Usuario",
  [CASCADE_STARTS_URL]: "Criterio de cascada",
  [GROUPS_URL]: "Grupos de artículos",
  [ARTICLE_LOCATION_STATE_URL]: "Estado de mercadería",
  [PREPICKING_VALIDATE_URL]: "Pre-picking",
  [ORDERS_URL]: "Pedido",
  [ORDERS_IMPORT_PREVIEW_URL]: "Preview de importacion de pedidos",
  [ORDERS_IMPORT_URL]: "Importacion de pedidos",
  [ORDERS_STATUS_BATCH_URL]: "Cambio masivo de estado de pedidos",
  [INCOME_ENTRIES_URL]: "Preingreso",
};
